export default function () {
  const widgetName = "fairSignupModule";
  const widgetOpts = fairSignupModuleOpts;
  const $widget = $(`#${widgetName}`);

  return saffire.widgets.cardWidget($($widget), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    scriptPath: widgetOpts.scriptPath,
    maxItemsVisible: 1,
    itemsPerPanel: 1,

    cardWidgetLoaded: function (data, _owl, hasData) {
      if (!hasData) {
        $(".homepage .tier-4-container").remove();
      } else {
        createCustomSignip(data.items);
      }
    },
  });

  function createCustomSignip(widgetData) {
    const { Title, Description } = widgetData[0];

    $(`#${widgetName}`).find(".card-widget-item").replaceWith(`
      <div class="signup-heading">
      <h3>${Title}</h3>
      <p>${Description}</p>
      </div>
      `);

    const $signupWidget = $(".tier-4-container").find(".emailSignup");
    const $signupInput = $signupWidget.find("input");
    $signupWidget.find(".emailSignupText").remove();
    $signupInput.val("");
    $signupInput.attr("placeholder", "Email Address");
    $signupWidget.find(".emailInputSubmit a").text("Subscribe");

    $signupInput
      .on("focus", function () {
        $(this).attr("placeholder", "");
      })
      .on("blur", function () {
        $(this).attr("placeholder", "Email Address");
      });
  }
}
